import { render, staticRenderFns } from "./LunchList.vue?vue&type=template&id=2675f81d&"
import script from "./LunchList.vue?vue&type=script&lang=js&"
export * from "./LunchList.vue?vue&type=script&lang=js&"
import style0 from "./LunchList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports